import { Action, combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import { asyncReducer } from '@wahaaabello/redux-async-actions';
import authActions from './modules/auth/actions';
import authReducer from './modules/auth/reducer';
import uiReducer from './modules/ui/reducer';
import formsReducer from './modules/forms/reducer';
import pagesReducer from './modules/pages/reducer';
import userReducer from './modules/user/reducer';
import targetsReducer from './modules/targets/reducer';
import investmentsReducer from './modules/investments/reducer';
import { AppState } from '../types';

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  forms: formsReducer,
  pages: pagesReducer,
  targets: targetsReducer,
  investments: investmentsReducer
});

const persistConfig = {
  key: 'app',
  blacklist: ['auth'],
  stateReconciler: autoMergeLevel2,
  storage
};

const nextAppReducer = (state: AppState | undefined, action: Action) => {
  if (action.type === authActions.logOut.toString()) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default combineReducers({
  app: persistReducer(persistConfig, nextAppReducer),
  ui: uiReducer,
  form: formReducer,
  async: asyncReducer
});
